module.exports = __webpack_public_path__ + "static/media/meh-blank.fe09c5cf.svg";